import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { PiSealWarningBold } from "react-icons/pi";
import { RiCloseCircleFill } from "react-icons/ri";

import { CustomToastifyProps } from "@models/shared/shared.model";

const CustomToastify: React.FC<CustomToastifyProps> = ({
  buttonText,
  content,
  onButtonClick,
  title,
  type,
}) => {
  const icon =
    type === "success" ? (
      <FaCheckCircle className="text-success" size={"28"} />
    ) : type === "error" ? (
      <RiCloseCircleFill className="text-danger" size={"32"} />
    ) : (
      <PiSealWarningBold className="text-black" />
    );

  return (
    <div className={"fg-toast-notification p-1 rounded w-100"}>
      <div className="d-flex align-items-center">
        <div className="me-3">{icon}</div>
        <div>
          {title && <h5 className="mb-1">{title}</h5>}
          {content && <p className="mb-0">{content}</p>}
        </div>
      </div>
      {buttonText && (
        <button
          onClick={onButtonClick}
          className="btn fg-btn fg-toastify-btn mt-2 w-100"
        >
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default CustomToastify;
